import React from "react";
import { Outlet } from "react-router-dom";

const ImageCertification = () => {
  return <Outlet />;
};

export default ImageCertification;
